module.exports = function _of(x) { return [x]; };



/*****************
 ** WEBPACK FOOTER
 ** ./~/ramda/src/internal/_of.js
 ** module id = 3109
 ** module chunks = 0
 **/